import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";
import { DynamicComponent } from "../../../utils/dynamic-loader/dynamic.component";
import { WysiwygDirective } from "../../../../directives/wysiwyg.directive";
import { LgAlertComponent, LgGridContainerDirective } from "@legal-and-general/canopy";
import { SafeHtmlPipe } from "../../../utils/pipes/safe-html..pipe";

@Component({
  selector: "dotcom-frontend-disclaimer",
  templateUrl: "./DisclaimerLayout.component.html",
  styleUrl: "./DisclaimerLayout.component.scss",
  standalone: true,
  imports: [
    WysiwygDirective,
    LgAlertComponent,
    LgGridContainerDirective,
    SafeHtmlPipe
  ],
  encapsulation: ViewEncapsulation.None
})
export class DisclaimerLayoutComponent implements DynamicComponent, OnInit {
  @Input() data!: CmsData;
  footerDisclaimerText: string | undefined;

  ngOnInit() {
    if (this.data) {
      this.footerDisclaimerText = this.data["footerDisclaimerText"];
    }
  }
}
